<template>
    <div class="">
        <div class="tw-mt-4 tw-flex tw-items-center" v-for="(value, index) in values" v-if="values.length > 0">
            <input type="hidden" :name="'contract_worktimes[' + index + '][id]'" :value="value.id">
            
            <div>
                <daily-worktime-select
                    :name="'contract_worktimes[' + index + '][weekly_worktime_hours_day]'"
                    :initial-values="value.weekly_worktime_hours_day"
                ></daily-worktime-select>
            </div>

            <div class="tw-ml-10">
                <bordered-input>
                    <template #label>
                        <label :for="'contract_worktimes_valid_from_' + index">
                            Gültig ab
                        </label>
                    </template>
                    <template #input>
                        <input class="tw-mr-4" :id="'contract_worktimes_valid_from_' + index" :name="'contract_worktimes[' + index + '][valid_from]'" type="date" placeholder="Gültig ab" v-model="value.valid_from">
                    </template>
                </bordered-input>
            </div>

            <button class="cu-btn-default tw-ml-2" type="button" @click="$event => addValue(index)">
                <i class="fa fa-plus"></i>
            </button>

            <button class="cu-btn-default tw-ml-2" type="button" @click="removeValue(index)">
                <i class="fa fa-trash-o"></i>
            </button>
        </div>
        <div class="tw-mt-4" v-if="values.length === 0">
            <button type="button" class="cu-btn-default" @click="addValue(-1)">
                <i class="fa fa-plus"></i>
                Arbeitszeit eintragen
            </button>
        </div>
    </div>
</template>

<script>
    import BorderedInput from "./BorderedInput";
    import DailyWorktimeSelect from "./DailyWorktimeSelect"
    import moment from 'moment';

    export default {
        components: {
            BorderedInput,
            DailyWorktimeSelect
        },

        props: {
            initialValues: {
                required: false,
                default: null,
                type: Array,
            },
        },

        data() {
            return {
                values: [],
            }
        },

        methods: {
            addValue(index) {
                let newVal = {
                    id: null,
                    valid_from: index == -1 ? 
                        moment().format('YYYY-MM-DD') : 
                        moment(this.values[index].valid_from).add(1, 'days').format('YYYY-MM-DD'),
                };
                newVal['weekly_worktime_hours_day'] = [8, 8, 8, 8, 8, 0, 0];
                this.values.splice(index + 1, 0, newVal);
            },

            removeValue(index) {
                this.values.splice(index, 1);
            },
        },

        mounted() {
            if (this.initialValues.length > 0) {
                this.initialValues.forEach(item => {
                    let newVal = {
                        id: item.id,
                        valid_from: item.valid_from ? 
                            moment(item.valid_from).format('YYYY-MM-DD') :
                            moment().format('YYYY-MM-DD'),
                    };
                    newVal['weekly_worktime_hours_day'] = item['weekly_worktime_hours_day'];
                    this.values.push(newVal);
                });
                // thanks to 'YYYY-MM-DD' sorting like strings works
                this.values.sort((a, b) => {
                    return moment(a.valid_from).diff(moment(b.valid_from));
                });
            }
        }
    }
</script>